import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  loaderService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-preparation-item-document.controller';
import directive from './attach-preparation-item-document.directive';


export default angular.module('app.components.advisory.auditTrail.attachPreparationItemDocument', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
  userService,
])
  .directive('amAttachPreparationItemDocument', directive)
  .controller('AttachPreparationItemDocumentController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachPreparationItemDocument created');
